import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appMaxDecimal]'
})
export class MaxDecimalDirective {
  @Input() appMaxDecimal: number = 3;

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInput(event: Event) {
    const input = this.el.nativeElement as HTMLInputElement;
    const value = input.value;

    const regex = new RegExp(`^\\d*(\\.\\d{0,${this.appMaxDecimal}})?$`);

    if (!regex.test(value)) {
      input.value = value.substring(0, value.length - 1);
    }
  }
}